var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook_svg__a)",
    d: "M11 .5C5.225.5.5 5.249.5 11.053c0 5.208 3.854 9.534 8.82 10.447v-7.492H6.695v-2.955H9.32V8.73c0-2.638 1.68-4.115 4.095-4.115.735 0 1.575.105 2.31.21v2.692H14.36c-1.26 0-1.575.633-1.575 1.477v2.058h2.783l-.473 2.954h-2.31v7.482c4.961-.918 8.715-5.228 8.715-10.436C21.5 5.249 16.775.5 11 .5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__a",
    x1: 11,
    x2: 11,
    y1: 20.872,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
};
export default SvgFacebook;